import React from 'react';
import moment from 'moment';
import { DataGridLayout, List, ListHeader, ListPageLayout } from 'framework/list';
import useDistributionService from 'domain/finance/payroll/payrollDistribution/usePayrollDistributionService';
import { DATE_FORMAT } from 'framework/utils';
import PayrollDistributionStaticFilters from 'domain/finance/payroll/payrollDistribution/List/PayrollDistributionStaticFilters';
import PayrollDistributionStatusField from 'domain/finance/payroll/payrollDistribution/shared/field/PayrollDistributionStatusField';
import { ExpandingField, TextField } from 'framework/ui/field';
import { EmployeeLinkFieldWithNameLoading } from 'domain/shared/employee';
import JournalEntryLink from 'domain/finance/journalEntry/shared/field/JournalEntryLink';

const PayrollDistributionListPage = () => {
  const { search } = useDistributionService();
  const currentMonth = moment().format(DATE_FORMAT.API_ONLY_MONTH);

  return (
    <List
      getDataMethod={search}
      defaultFilter={{
        period: {
          eq: currentMonth,
        },
      }}
    >
      <ListPageLayout header={<PayrollDistributionStaticFilters title={<ListHeader label="Payroll Distribution" />} />}>
        <DataGridLayout>
          <TextField source="period" />
          <EmployeeLinkFieldWithNameLoading source="employeeAlias" />
          <TextField source="sourceTransferId" label="Source Transfer ID" />
          <TextField source="costCenterReportId" label="Cost Center Report ID" />
          <JournalEntryLink source="journalEntryId" label="Journal Entry ID" />
          <PayrollDistributionStatusField source="status" width={140} />
          <ExpandingField source="skippedReason" label="Skipped Reason" width={260} maxValueLength={124}>
            <TextField source="skippedReason" />
          </ExpandingField>
        </DataGridLayout>
      </ListPageLayout>
    </List>
  );
};

export default PayrollDistributionListPage;
